<template>
  <div
    class="syncc-stories-feed__zoom-content--storyvideo-7bct2Odbwe"
    :class="{
      'syncc-stories-feed__zoom-content-horizontal--storyvideo-SDe3pxn1':
        this.isHorizontalVideo,
      'syncc-stories-feed__desktop-user-display-container-kK38cnssd':
        !this.isMobileEnvUser,
    }"
  >
    <interactive-video-loading
      v-if="isLoadingVideo"
      :isHorizontal="isHorizontalVideo"
    ></interactive-video-loading>
    <div
      v-for="(partData, index) in partListForTemplate"
      :key="partData.partId"
    >
      <div
        v-show="currentPartId == partData.partId"
        class="syncc-stories-feed__story_video-container-position-sk2Ldmo299"
      >
        <interactive-video
          v-show="!isLoadingVideo"
          :id="resolveVideoContainer(index)"
          :key="resolveVideoContainer(index)"
          :ref="resolveVideoContainer(index)"
          :partId="partData.partId"
          :videoObjectFitStyle="videoObjectFitStyle"
          :currentSelectedVideo="currentPartId == partData.partId"
          :playbackId="partData.video.mux_playback_id"
          :jwt="partData.video.mux_jwt"
          :videoThumbnailSrc="partData.videoThumbnailSrc"
          v-on:can-play="handleCreateViewPartAnalyticsEvent"
          v-on:next-video-request="switchToNextStory"
          v-on:on-get-video-duration="setVideoDuration"
          v-on:on-update-video-process-time="handleTimeUpdateProc"
          v-touch:tap="touchHandler"
          v-touch:touchhold="touchHoldHandler"
          v-touch:swipe.left="swipeLeftHandler"
          v-touch:swipe.right="swipeRightHandler"
          v-touch:swipe.bottom="swipeBottomHandler"
          v-touch:end="endHandler"
          class="syncc-stories-feed__video-K8eklU93N"
        >
        </interactive-video>
        <div
          class="syncc-stories-feed__on-video-overlay-container-on-page-link-n31BDlew"
        >
          <transition name="fade">
            <div
              id="choices-container"
              v-show="choiceShow && currentPartId == partData.partId"
              class="syncc-stories-feed__choices-container-on-video-Nre77iuc syncc-player__choices-container-on-video-vertical-dm21NOwcc"
            >
              <single-choice
                v-for="choice in partData.plainChoices"
                :key="choice.id"
                :choice="choice"
                :themeColor="themeColor"
                :isHorizontalVideo="isHorizontalVideo"
                v-on:next-video-part="disposeVideo"
                v-on:on-process-update-watch-status="
                  sendWatchStatusEngagementEvent
                "
                v-on:on-process-choice-select="sendChoiceSelectEngagementEvent"
              ></single-choice>
              <single-choice
                v-for="choice in partData.mainCTAChoices"
                :key="choice.id"
                :choice="choice"
                :themeColor="themeColor"
                :isHorizontalVideo="isHorizontalVideo"
                v-on:next-video-part="disposeVideo"
                v-on:on-process-update-watch-status="
                  sendWatchStatusEngagementEvent
                "
                v-on:on-process-choice-select="sendChoiceSelectEngagementEvent"
              ></single-choice>
            </div>
          </transition>
        </div>
        <div
          style="
            margin-top: 30px;
            margin-left: 8px;
            z-index: 999 !important;
            display: flex;
          "
          class="syncc-stories-feed__story-info-overlay-container-lpdxQAd30"
        >
          <img
            :src="teamLogo"
            width="35"
            height="35"
            style="border-radius: 50%; vertical-align: middle"
          />
          <div
            style="
              max-width: 288px;
              overflow: hidden;
              text-overflow: ellipsis;
              color: #fff;
              margin: auto;
            "
          >
            <span
              style="
                font-family: -apple-system;
                margin-left: 10px;
                color: #fff !important;
                white-space: nowrap;
                text-overflow: ellipsis;
                max-width: 5rem;
                font-size: 14px;
                font-weight: 500;
                box-sizing: border-box;
                overflow-x: hidden;
                text-align: center;
              "
              >{{ partData.part.title }}</span
            >
          </div>
        </div>
        <close-btn
          style="margin-top: 33px; margin-right: 6px; z-index: 999 !important"
          class="syncc-stories-feed__video-close-btn-Ake8ck3"
          v-on:close-el="closeVideoContainer"
        />
        <button
          id="goToPreviousVideoBtn"
          style="
            position: absolute;
            top: 43%;
            left: 0;
            box-sizing: content-box;
            padding-top: 10px;
            padding-bottom: 10px;
            cursor: pointer;
            border-radius: 50%;
            border: none;
            width: 30px;
            height: 30px;
            background-color: transparent;
          "
          @click.prevent="switchToPreviousStory"
        >
          <back />
        </button>
        <button
          id="goToNextVideoBtn"
          style="
            position: absolute;
            top: 43%;
            right: 0;
            box-sizing: content-box;
            padding-top: 10px;
            padding-bottom: 10px;
            cursor: pointer;
            border-radius: 50%;
            border: none;
            width: 30px;
            height: 30px;
            background-color: transparent;
            transform: scale(-1, 1);
          "
          @click.prevent="switchToNextStory"
        >
          <back />
        </button>
      </div>
    </div>
    <div :style="logoStyle" @click="routeToSynccServicePage">
      <img :src="logo" style="max-width: 47px" />
    </div>
  </div>
</template>

<script>
import Config from "../models/Config";
import Customization from "../models/Customization";
import Choice from "../models/Choice";
import Part from "../models/Part";
import PartOrder from "../models/PartOrder";
import Story from "../models/Story";
import Video from "../models/Video";
import EngagedUser from "../models/EngagedUser";
import UserEngagement from "../models/UserEngagement";
import UserVideoEngagement from "../models/UserVideoEngagement";

import Chapter from "../components/UI/Chapter.vue";
import InteractiveVideo from "../components/UI/InteractiveVideo.vue";
import InteractiveVideoLoading from "../components/UI/InteractiveVideoLoading.vue";
import SingleChoice from "../components/UI/SingleChoice.vue";

import InteractiveConversationBeginChip from "../components/UI/InteractiveConversationBeginChip.vue";
import CloseBtn from "../components/UI/CloseBtn.vue";
import Back from "../components/UI/icons/svg/Back.vue";

import store from "../store/index";

export default {
  props: {},
  components: {
    Chapter,
    InteractiveVideo,
    InteractiveVideoLoading,
    SingleChoice,
    InteractiveConversationBeginChip,
    CloseBtn,
    Back,
  },
  data() {
    return {
      partListForTemplate: [],
      currentPartId: "",
      currentPartIndex: 0,
      videoDurations: [],
      partOrder: Object,
      showAnswerChoiceTimeIntervalInSec: Number,
      heartbeatEngagementRequestSecCount: 0,
      isLoadingVideo: false,
      initialPart: false,
      choiceShow: false,
      isHorizontalVideo: true,
      videoObjectFitStyle: "",
      teamLogo: "",
      themeColor: "",
      teamSlug: String,
      isMobileEnvUser: false,
      doneWatchProgressEngagementEventRequesting: false,
      doneCreateVideoViewEngagementEventRequesting: false,
      isHoldingVideo: false,
      previousBodyStyle: null,
      logo: "",
      logoStyle: {},
    };
  },
  created() {
    /* Video thumbnail handling */
    // パート関連ここから
    const parts = Part.all();
    const videos = Video.all();
    const config = Config.all()[0];
    for (var i = 0; i < parts.length; i++) {
      const choices = Choice.query()
        .where("part_id", parts[i].part_id)
        .where("is_main_cta", false)
        .orderBy("display_priority", "asc")
        .get();
      const mainCTAChoices = Choice.query()
        .where("part_id", parts[i].part_id)
        .where("is_main_cta", true)
        .orderBy("display_priority", "asc")
        .get();
      this.partListForTemplate.push({
        partId: parts[i].part_id,
        part: parts[i],
        video: videos[i],
        plainChoices: choices,
        mainCTAChoices: mainCTAChoices,
        showAnswerChoiceTimeIntervalInSec: parts[i].choices_display_timeout,
        videoThumbnail: config.icon_loop
          ? "https://image.mux.com/" +
            videos[i].mux_playback_id +
            "/animated.gif?fps=15&width=640&height=640&start=2.5&token=" +
            videos[i].mux_jwt_for_gif
          : "https://image.mux.com/" +
            videos[i].mux_playback_id +
            "?token=" +
            videos[i].mux_jwt_for_img,
      });
    }

    this.currentPartId = this.$route.params["id"];
    this.partOrder = PartOrder.query()
      .where("current_part_id", this.currentPartId)
      .get()[0];

    let story = Story.all()[0];
    this.teamLogo = story.team_logo;
    this.teamSlug = story.team_slug;

    /* Design Customization handling */
    let customization = Customization.all()[0];
    this.themeColor = customization.theme_color;
    this.isHorizontalVideo =
      customization.video_orientation == "HORIZONTAL_VIDEO";
    if (customization.stories_feed_object_fit_type) {
      this.videoObjectFitStyle = customization.stories_feed_object_fit_type;
    } else {
      this.videoObjectFitStyle = "COVER";
    }

    /* Syncc brand logo handling */
    const isProduction = process.env.NODE_ENV === "production";
    if (isProduction) {
      this.logo =
        "https://syncc-stories-feed.web.app/img/syncc-logo-by-product.png";
    } else {
      this.logo = require("@/assets/img/syncc-logo.png");
    }

    this.conversionVideo();
  },
  mounted() {
    this.setScrollDiable();
    window.addEventListener(
      "beforeunload",
      this.handleWatchProgressPatchEventRequest
    );

    const { os, browser, isMobile } = this.getEnv();
    this.logoStyle = {
      position: "absolute",
      bottom: "1%",
      left: "8%",
      transform: "translateX(-50%)",
      zIndex: "1000 !important",
    };

    this.isMobileEnvUser = isMobile;
  },
  beforeDestroy() {},
  watch: {
    currentPartId: function (newVal, oldVal) {
      if (newVal == oldVal) {
        return;
      } else {
        this.doneWatchProgressEngagementEventRequesting = false;
        this.doneCreateVideoViewEngagementEventRequesting = false;
        this.currentPartIndex = this.partListForTemplate
          .map((e) => e.partId)
          .indexOf(this.currentPartId);
        this.showAnswerChoiceTimeIntervalInSec =
          this.partListForTemplate[
            this.currentPartIndex
          ].showAnswerChoiceTimeIntervalInSec;
        this.sendVideoViewStartPartEngagementEvent();
      }
    },
  },
  computed: {},
  methods: {
    resolveVideoContainer(index) {
      return "interactionVideo" + index;
    },
    switchToNextStory() {
      if (this.partOrder.next_part_id) {
        this.handleWatchProgressPatchEventRequest();
        this.choiceShow = false;
        this.currentPartId = this.partOrder.next_part_id;
        this.partOrder = PartOrder.query()
          .where("current_part_id", this.partOrder.next_part_id)
          .get()[0];
      }
    },
    switchToPreviousStory() {
      if (this.partOrder.previous_part_id) {
        this.handleWatchProgressPatchEventRequest();
        this.choiceShow = false;
        this.currentPartId = this.partOrder.previous_part_id;
        this.partOrder = PartOrder.query()
          .where("current_part_id", this.partOrder.previous_part_id)
          .get()[0];
      }
    },
    touchHandler(e) {
      const tapPagePostionX = e.pageX;
      var clientWidth = window.screen.width;
      if (tapPagePostionX > Math.round(clientWidth / 2)) {
        this.switchToNextStory();
      } else {
        this.switchToPreviousStory();
      }
    },
    touchHoldHandler() {
      this.isHoldingVideo = true;
      const refName = this.resolveVideoContainer(this.currentPartIndex);
      this.$refs[refName][0].pause();
    },
    swipeLeftHandler() {
      this.switchToNextStory();
    },
    swipeRightHandler() {
      this.switchToPreviousStory();
    },
    swipeBottomHandler() {
      if (!this.isHoldingVideo) {
        this.closeVideoContainer();
      }
    },
    endHandler() {
      if (this.isHoldingVideo) {
        this.isHoldingVideo = false;
        const refName = this.resolveVideoContainer(this.currentPartIndex);
        this.$refs[refName][0].resume();
      }
    },
    routeToSynccServicePage() {
      const serviceUrl = "https://syncc.unstack.website/";
      window.open(serviceUrl, "_blank", "noopener");
    },
    async conversionVideo() {
      let engagedUser = EngagedUser.all()[0];
      if (!engagedUser.engaged_user_id) {
        const { newUser, engagedUserId } = await this.getEngageUser(
          this.teamSlug
        );
        EngagedUser.update({
          where: "0",
          data: {
            newUser: newUser,
            engagedUserId: engagedUserId,
          },
        });
        let engagement = UserEngagement.all()[0];
        this.sendUpdateEngagementWithEngagedUser(
          engagement.engagement_id,
          engagedUserId
        );
      }
    },
    handleCreateViewPartAnalyticsEvent() {
      setTimeout(() => {
        if (!this.doneCreateVideoViewEngagementEventRequesting) {
          this.sendVideoViewStartPartEngagementEvent();
        }
      }, 1);
    },
    setScrollDiable() {
      this.previousBodyStyle = document.getElementsByTagName("body")[0].style;
      document.getElementsByTagName("body")[0].style =
        "touch-action: none !important; background-color: #000 !important";
    },
    setVideoDuration({ partId, videoDuration }) {
      this.videoDurations.push({ partId: partId, duration: videoDuration });
    },
    handleTimeUpdateProc(currentTime) {
      // Choice Timeset
      if (
        currentTime > this.showAnswerChoiceTimeIntervalInSec &&
        !this.choiceShow
      ) {
        this.choiceShow = true;
      }
      // Hanlde engagement
      if (currentTime) {
        let videoEngagement = UserVideoEngagement.all()[0];
        let videoWatchingSeconds =
          videoEngagement.current_engaging_video_watching_seconds;
        if (currentTime > videoWatchingSeconds) {
          UserVideoEngagement.update({
            data: {
              id: 0,
              current_engaging_video_watching_seconds: parseInt(currentTime),
            },
          });
          if (
            parseInt(currentTime) % 3 === 0 &&
            parseInt(currentTime) > this.heartbeatEngagementRequestSecCount
          ) {
            this.heartbeatEngagementRequestSecCount = parseInt(currentTime);
            // Heartbeat like api request per every 3 seconds
            this.sendWatchStatusEngagementEvent(true);
          }
        }
      }
    },
    closeVideoContainer() {
      document.getElementsByTagName("body")[0].style = this.previousBodyStyle
        ? this.previousBodyStyle
        : ``;
      this.handleWatchProgressPatchEventRequest();
      //this.disposeVideo();
      this.$router.push({
        name: "story-icons",
        params: { id: "" },
      });
    },
    disposeVideo() {
      const refName = this.resolveVideoContainer(this.currentPartIndex);
      this.$refs[refName][0].disposeVideo();
    },
    handleWatchProgressPatchEventRequest() {
      if (!this.doneWatchProgressEngagementEventRequesting) {
        this.sendWatchStatusEngagementEvent(false);
      }
    },
    sendVideoViewStartPartEngagementEvent() {
      if (this.doneCreateVideoViewEngagementEventRequesting) {
        return;
      } else {
        this.doneCreateVideoViewEngagementEventRequesting = true;
        let engagement = UserEngagement.all()[0];
        const payload = {
          partId: this.currentPartId,
          engagementId: engagement.engagement_id,
          eventType: "VIDEO_VIEW_STARTED",
          selctedChoiceLabel: "",
          choiceLabels: [],
          btnClick: 1,
          timeSpentInSeconds: 0,
          videoPercentageWatched: 0,
        };
        store
          .dispatch("createPartEngagementEvent", payload)
          .then((response) => {
            EngagedUser.update({
              where: "0",
              data: {
                current_engaging_part_event_id:
                  response.data.part_engagement_id,
              },
            });
          });
      }
    },
    sendUpdateEngagementWithEngagedUser(engagementId, engagedUserId) {
      const payload = {
        engagementId: engagementId,
        engagedUserId: engagedUserId,
      };
      store.dispatch("updateEngagementWithEngagedUser", payload);
    },
    sendWatchStatusEngagementEvent(isHeartbeatRequest = false) {
      if (!isHeartbeatRequest) {
        this.doneWatchProgressEngagementEventRequesting = true;
      }
      let engagedUser = EngagedUser.all()[0];
      let videoEngagement = UserVideoEngagement.all()[0];
      const targetObjIndex = this.videoDurations
        .map((e) => e.partId)
        .indexOf(this.currentPartId);
      const videoDuration = this.videoDurations[targetObjIndex].duration;
      var videoPercentageWatched =
        (videoEngagement.current_engaging_video_watching_seconds /
          videoDuration) *
        100;
      if (engagedUser.current_engaging_part_event_id) {
        const payload = {
          partEngagementId: engagedUser.current_engaging_part_event_id,
          timeSpentInSeconds:
            videoEngagement.current_engaging_video_watching_seconds,
          videoPercentageWatched: parseInt(videoPercentageWatched),
        };
        store
          .dispatch("setVideoWatchStatsOnPartEngagementEvent", payload)
          .then((_) => {
            if (!isHeartbeatRequest) {
              UserVideoEngagement.update({
                data: {
                  id: 0,
                  current_engaging_video_watching_seconds: 0,
                },
              });
            }
          });
      }
    },
    sendChoiceSelectEngagementEvent({ eventType, selectedChoiceLabel }) {
      let engagement = UserEngagement.all()[0];
      let plainChoices =
        this.partListForTemplate[this.currentPartIndex].plainChoices;
      let mainCTAChoices =
        this.partListForTemplate[this.currentPartIndex].mainCTAChoices;
      let allChoices = plainChoices.concat(mainCTAChoices);
      let choiceLabelsArr = allChoices.map(
        (choice) => choice.in_choice_text_content
      );
      const payload = {
        partId: this.currentPartId,
        engagementId: engagement.engagement_id,
        eventType: eventType,
        selctedChoiceLabel: selectedChoiceLabel,
        choiceLabels: choiceLabelsArr,
        btnClick: 1,
        timeSpentInSeconds: 0,
        videoPercentageWatched: 0,
      };
      store.dispatch("createPartEngagementEvent", payload);
    },
    resolveUserFromViewerDataArr(viewerData, teamSlug) {
      if (viewerData) {
        for (var i = 0; i < viewerData.length; i++) {
          if (viewerData[i].team_slug == teamSlug) {
            return {
              isExistingEngagedUser: true,
              engagedUserId: viewerData[i].viewer_id,
            };
          }
          if (
            i === viewerData.length - 1 &&
            viewerData[i].team_slug !== teamSlug
          ) {
            return {
              isExistingEngagedUser: false,
              engagedUserId: "",
            };
          }
        }
      } else {
        return {
          isExistingEngagedUser: false,
          engagedUserId: "",
        };
      }
    },
    async getEngageUser(teamSlug) {
      var viewerDataArr = JSON.parse(localStorage.getItem("synccViewerData"));
      const { isExistingEngagedUser, engagedUserId } =
        this.resolveUserFromViewerDataArr(viewerDataArr, teamSlug);
      if (isExistingEngagedUser) {
        return {
          newUser: false,
          engagedUserId: engagedUserId,
        };
      } else {
        const urlParams = new URLSearchParams(window.location.search);
        const personId = urlParams.get("person")
          ? urlParams.get("person")
          : null;
        var _engagedUserId = "";
        if (personId) {
          const payload = {
            teamSlug: teamSlug,
            personId: personId,
          };
          await store
            .dispatch("createEngagedUser", payload)
            .then((response) => {
              _engagedUserId = response.data.engaged_user_id;
              if (viewerDataArr) {
                viewerDataArr.push({
                  team_slug: teamSlug,
                  viewer_id: _engagedUserId,
                });
                localStorage.setItem(
                  "synccViewerData",
                  JSON.stringify(viewerDataArr)
                );
              } else {
                const newViewerDataArr = [
                  {
                    team_slug: teamSlug,
                    viewer_id: _engagedUserId,
                  },
                ];
                localStorage.setItem(
                  "synccViewerData",
                  JSON.stringify(newViewerDataArr)
                );
              }
            });
          return {
            newUser: true,
            engagedUserId: _engagedUserId,
          };
        } else {
          const payload = {
            teamSlug: teamSlug,
          };
          await store
            .dispatch("createAnonymousEngagedUser", payload)
            .then((response) => {
              _engagedUserId = response.data.engaged_user_id;
              if (viewerDataArr) {
                viewerDataArr.push({
                  team_slug: teamSlug,
                  viewer_id: _engagedUserId,
                });
                localStorage.setItem(
                  "synccViewerData",
                  JSON.stringify(viewerDataArr)
                );
              } else {
                const newViewerDataArr = [
                  {
                    team_slug: teamSlug,
                    viewer_id: _engagedUserId,
                  },
                ];
                localStorage.setItem(
                  "synccViewerData",
                  JSON.stringify(newViewerDataArr)
                );
              }
            });
          return {
            newUser: true,
            engagedUserId: _engagedUserId,
          };
        }
      }
    },
    getEnv() {
      var ua = window.navigator.userAgent.toLowerCase();

      var os = "";
      if (ua.indexOf("windows nt") !== -1) {
        os = "Microsoft Windows";
      } else if (ua.indexOf("android") !== -1) {
        os = "Android";
      } else if (ua.indexOf("iphone") !== -1 || ua.indexOf("ipad") !== -1) {
        os = "iOS";
      } else if (ua.indexOf("mac os x") !== -1) {
        os = "macOS";
      } else {
        os = "不明";
      }

      var browser = "";
      if (
        ua.indexOf("edge") !== -1 ||
        ua.indexOf("edga") !== -1 ||
        ua.indexOf("edgios") !== -1
      ) {
        browser = "Microsoft Edge";
      } else if (ua.indexOf("opera") !== -1 || ua.indexOf("opr") !== -1) {
        browser = "Opera";
      } else if (ua.indexOf("samsungbrowser") !== -1) {
        browser = "Samsung Internet Browser";
      } else if (ua.indexOf("ucbrowser") !== -1) {
        browser = "UC Browser";
      } else if (ua.indexOf("chrome") !== -1 || ua.indexOf("crios") !== -1) {
        browser = "Google Chrome";
      } else if (ua.indexOf("firefox") !== -1 || ua.indexOf("fxios") !== -1) {
        browser = "Mozilla Firefox";
      } else if (ua.indexOf("safari") !== -1) {
        browser = "Safari";
      } else if (ua.indexOf("msie") !== -1 || ua.indexOf("trident") !== -1) {
        browser = "Internet Explorer";
      } else {
        browser = "不明";
      }

      var isMobile = navigator.userAgent.match(
        /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
      );

      return { os: os, browser: browser, isMobile: isMobile };
    },
  },
};
</script>
